import {Modal, Notice, Message} from 'iview';
import l from './abp.localization'
/* NOTIFICATION *********************************************/
var notify = {};

notify.success = function (message, title, options) {
  return new Promise((resolve, reject) => {
    Message.success({
      content: message,
      duration:5,
      onClose: () => resolve(),
    });
  });
};

notify.info = function (message, title, options) {
  return new Promise((resolve, reject) => {
    Message.info({
      content: message,
      duration:5,
      onClose: () => resolve(),
    });
  });
};

notify.warn = function (message, title, options) {
  return new Promise((resolve, reject) => {
    Message.warning({
      content: message,
      duration:5,
      onClose: () => resolve(),
    });
  });
};

notify.error = function (message, title, options) {
  return new Promise((resolve, reject) => {
    Message.error({
      content: message,
      duration:5,
      onClose: () => resolve(),
    });
  });
};


/* MESSAGE **************************************************/
var message = {};

message.info = function (message, title) {
  return new Promise((resolve, reject) => {
    Modal.info({
      title: title || '提示',
      content: message,
      onOk: () => resolve(),
    });
  });
};

message.success = function (message, title) {
  return new Promise((resolve, reject) => {
    Modal.success({
      title: title || '成功',
      content: message,
      onOk: () => resolve(),
    });
  });
};

message.warn = function (message, title) {
  return new Promise((resolve, reject) => {
    Modal.warning({
      title: title || '提示',
      content: message,
      onOk: () => resolve(),
    });
  });
};

message.error = function (message, title) {
  return new Promise((resolve, reject) => {
    Modal.error({
      title: title || '错误',
      content: message,
      onOk: () => resolve(),
    });
  });
};

message.confirm = function (message, title) {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: title || "提示",
      content: message,
      onOk: () => resolve(),
      onCancel: () => reject()
    });
  });
};


export {notify, message}



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/utils/abp.vue.implemented.js